import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderCargoOrderHistory from "./order-cargo-order-history";
import OrderCargoOrderHistoryParams from "./order-cargo-order-history-params";

const useOrderCargoOrderHistory = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<OrderCargoOrderHistory | null>(null);

  const load = async (
    params: OrderCargoOrderHistoryParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const cargoOrderHistory: OrderCargoOrderHistory =
        await orderService.getCargoOrderHistory(params, signal);

      setData(cargoOrderHistory);
      setIsLoading(false);
    } catch (error) {
      setIsError(true);
      setData(null);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setIsError(false);
    setIsLoading(true);
    setData(null);
  };

  return {
    data,
    isError,
    isLoading,
    load,
    reset,
  };
};

export default useOrderCargoOrderHistory;
